<script setup lang="ts">
import { computed, ref } from 'vue';
import { LinkButton, viewportSize, useTranslation, SPANISH_LOCALE } from '@hfc/ui-core';
import { Popover, PopoverPanel } from '@headlessui/vue';

defineProps<{
  phoneNumber: string,
  showPhoneIcon?: boolean,
  emphasizedPhone?: boolean,
  forceSmallWidth?: boolean,
}>();

const { viewport } = viewportSize();
const { t } = useTranslation();

const popoverOpen = ref(false);
const isSpanish = computed(() => document.documentElement.lang === SPANISH_LOCALE);

</script>
<template>
  <template v-if="!isSpanish">
    <LinkButton v-if="viewport.isMobile" v-bind="$props" :href='`tel:${phoneNumber}`'>
      <hfc-icon class="text-2xl hover:text-blue-300 dark:text-white text-blue flex cursor-pointer" :class="{ 'max-2xs:text-xl': forceSmallWidth }" icon="phone" />
    </LinkButton>
    <Popover v-if="!viewport.isMobile && showPhoneIcon" class="flex lg:hidden relative" v-click-outside="() => popoverOpen = false">
      <hfc-icon class="text-2xl hover:text-blue-300 dark:text-white text-blue flex cursor-pointer" :class="{ 'max-2xs:text-xl': forceSmallWidth }" icon="phone" @click="popoverOpen =! popoverOpen"/>
      <div v-show="popoverOpen">
        <PopoverPanel :static="true" class="absolute left-1/2 z-10 mt-3 -translate-x-1/2 transform px-4 sm:px-0 w-36">
          <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-blue-900 ring-opacity-5">
            <div class="bg-blue-50 p-4 text-center">
              <span class="text-sm font-medium text-blue-500">
                {{phoneNumber}}
              </span>
            </div>
          </div>
        </PopoverPanel>
      </div>
    </Popover>
    <LinkButton v-if="!viewport.isMobile" :class="{ 'flex': !showPhoneIcon, 'hidden lg:flex': showPhoneIcon }" v-bind="$props" :href='`tel:${phoneNumber}`'>
      <template v-if="emphasizedPhone">
        <div class="flex flex-col gap-1">
          <div class="text-2xl font-bold text-blue-500">
            {{phoneNumber}}
          </div>
          <div class="text-xs text-gray-500 w-full text-center text-[13px]">
            {{ t('common.tagline') }}
          </div>
        </div>
      </template>
      <template v-else>
        {{phoneNumber}}
      </template>
    </LinkButton>
  </template>
</template>
